<template>
  <div class="progress-list">
    <div
      v-for="(item, index) in items"
      :key="item.key || index"
      class="progress-list__row"
    >
      <div class="progress-list__copy">
        <strong>{{ item.label }}</strong>
        <small v-if="item.detail">{{ item.detail }}</small>
      </div>
      <el-progress
        class="progress-list__progress"
        :percentage="percentage(item)"
        :show-text="false"
        :stroke-width="7"
        :status="item.status || undefined"
      />
      <strong class="progress-list__total">
        {{ item.value }} / {{ item.total }}
      </strong>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    percentage (item) {
      if (!item.total) return 0

      return Math.min(100, Math.round((item.value / item.total) * 100))
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-list__row {
  align-items: center;
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(150px, 1fr) minmax(180px, 2fr) 56px;
  min-height: 58px;
}

.progress-list__copy {
  display: flex;
  flex-direction: column;
  min-width: 0;

  strong {
    color: #29313c;
    font-size: 12px;
  }

  small {
    color: #8a9099;
    margin-top: 4px;
  }
}

.progress-list__total {
  color: #29313c;
  font-size: 11px;
  text-align: right;
}

@media (max-width: 700px) {
  .progress-list__row {
    gap: 8px 12px;
    grid-template-columns: 1fr auto;
    padding: 9px 0;
  }

  .progress-list__progress {
    grid-column: 1 / -1;
    grid-row: 2;
  }
}
</style>
